<template>
    <v-row class="mt-0 mb-5" id="listing-header">
        <v-img
            v-if="
                listing.banner &&
                listing.banner.background &&
                listing.banner.background.url &&
                ((listing.logo && listing.logo.url) || listing.banner.logo)
            "
            position="left top"
            id="listing-banner"
            :src="listing.banner.background.url"
        >
        </v-img>

        <v-container class="container-width">
            <v-row
                class="header-row mt-0 mx-0 pb-5 py-sm-0"
                no-gutters
                align-content="center"
            >
                <v-col
                    class="pt-0 mb-4 mb-sm-0"
                    cols="12"
                    sm="12"
                    md="2"
                    align-self="center"
                >
                    <v-img
                        v-if="
                            listing.banner &&
                            listing.banner.background &&
                            listing.banner.logo
                        "
                        max-height="70"
                        contain
                        class="my-5 my-md-0"
                        :src="listing.banner.logo.url"
                    >
                    </v-img>
                    <v-img
                        v-else-if="listing.logo && listing.logo.url"
                        max-height="70"
                        contain
                        class="my-5 my-md-0"
                        :src="listing.logo.url"
                    >
                    </v-img>
                    <h1 v-else>{{ listing.headline }}</h1>
                </v-col>

                <v-col cols="12" sm="7" :md="hasSchemes ? '6' : '7'">
                    <v-row align-items="center">
                        <v-col cols="12" md="5" class="listing-address pb-0">
                            <p class="mb-0">
                                <v-icon color="primary">mdi-map-marker</v-icon>
                                <span v-if="listing.displayAddress">{{
                                    listing.displayAddress
                                }}</span>
                                <span v-if="listing.postcode"
                                    >, {{ listing.postcode }}</span
                                >
                            </p>
                        </v-col>

                        <v-col class="stats" cols="12" md="7">
                            <v-row class="mx-lg-0">
                                <Specs
                                    :options="specsOptions"
                                    :listing="listing"
                                ></Specs>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" sm="5" :md="hasSchemes ? '4' : '3'">
                    <v-row align-items="center">
                        <v-col
                            v-if="hasSchemes"
                            class="vd-none vd-sm-block"
                            cols="12"
                            md="6"
                            align-self="center"
                        >
                            <SchemeSwitcher :listing="listing"></SchemeSwitcher>
                        </v-col>

                        <v-col
                            class="mt-4 mt-sm-0"
                            cols="12"
                            :md="hasSchemes ? '6' : '12'"
                            align-self="center"
                        >
                            <v-btn
                                href="#register"
                                block
                                x-large
                                elevation="0"
                                color="primary"
                                class="tt-none"
                            >
                                Register interest
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-row>
</template>

<script>
import { defineComponent, ref, computed } from "@vue/composition-api";
import Specs from "./micro/listing/Specs.vue";
import SchemeSwitcher from "./micro/listing/SchemeSwitcher.vue";
import { has, merge } from "lodash";

export default defineComponent({
    name: "ListingHeader",
    props: {
        listing: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
        },
    },
    components: { Specs, SchemeSwitcher },
    setup(props, context) {
        const defaultOptions = ref({});

        const normalizedOptions = computed(() => {
            return merge(defaultOptions.value, props.options);
        });

        const specsOptions = computed(() => {
            if (has(props, "options.stats")) {
                return props.options.stats;
            }
            return null;
        });

        const hasSchemes = computed(() => {
            if (props.listing.availableSchemes) {
                return props.listing.availableSchemes.length > 0;
            }

            return false;
        });

        return {
            hasSchemes,
            specsOptions,
            normalizedOptions,
        };
    },
});
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

#listing-header {
    position: relative;
    overflow: hidden;

    #listing-banner {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 30%;
        height: auto;
        &:after {
            position: absolute;
            content: "";
            width: 30%;
            right: 0;
            top: 0;
            bottom: 0;
        }
        @media #{map-get($display-breakpoints, 'md-and-down')} {
            width: 100%;
        }
    }

    .header-row {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 100px;
        z-index: 1;
        background: rgb(255, 255, 255);
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 8%,
            rgba(241, 243, 245, 0.8) 15%,
            rgba(241, 243, 245, 0.9) 20%,
            rgba(241, 243, 245, 1) 25%
        );
        @media #{map-get($display-breakpoints, 'lg-and-up')} {
            background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(241, 243, 245, 0.8) 10%,
                rgba(241, 243, 245, 1) 17%
            );
        }
        .listing-address {
            display: flex;
            align-items: center;
            padding-left: 70px;

            @media #{map-get($display-breakpoints, 'md-and-down')} {
                padding-left: 12px;
            }
        }

        @media #{map-get($display-breakpoints, 'md-and-down')} {
            padding-left: 15px;
            padding-right: 15px;

            .v-image {
                max-width: 400px;
            }

            .listing-address {
                padding-bottom: 0px;
            }
        }

        @media #{map-get($display-breakpoints, 'sm-and-down')} {
            background: transparent !important;
        }

        @media #{map-get($display-breakpoints, 'xs-only')} {
            .listing-address {
                justify-content: center;
            }
        }
    }
}
</style>
